<template>
  <section >

    <b-tabs v-model="activeTab" type="is-toggle" style="padding:20px;">
      <b-tab-item :label="`All (${shopProducts.length})`">
        <orders-table :data="shopProducts" :isLoading="isLoading" @reloadOrders="getShopProducts" :show-status="true">
        </orders-table>
      </b-tab-item>
      <!-- <b-tab-item :label="`Pending (${pendingEquipmentRequests.length})`">
        <orders-table :data="pendingEquipmentRequests" :isLoading="isLoading" @reloadOrders="getEquipmentRequests" :show-status="true">
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Accepted (${acceptedOrders.length})`">
        <orders-table :data="acceptedOrders" :isLoading="isLoading" @reloadOrders="getEquipmentRequests" :show-status="true">
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Dispatched (${dispatchedEquipmentRequests.length})`">
        <orders-table :data="dispatchedEquipmentRequests" :isLoading="isLoading" @reloadOrders="getEquipmentRequests" :show-status="true">
        </orders-table>
      </b-tab-item>

      <b-tab-item :label="`Delivered (${deliveredEquipmentRequests.length})`">
        <orders-table :data="deliveredEquipmentRequests" :isLoading="isLoading" @reloadOrders="getEquipmentRequests"></orders-table>
      </b-tab-item>

      <b-tab-item :label="`Returned (${returnedEquipmentRequests.length})`">
        <orders-table :data="returnedEquipmentRequests" :isLoading="isLoading" @reloadOrders="getEquipmentRequests"></orders-table>
      </b-tab-item> -->

    </b-tabs>
  </section>
</template>

<script>
  import OrdersTable from '@/components/Shop/ProductsTable';
  import FilterComponent from '@/components/Shared/Filters';
  import { mapActions, mapGetters } from "vuex";
  import {
    mdy
  } from '@/helpers';
  export default {
    name: "ShopProducts",
    components: {
      OrdersTable,
      FilterComponent,
      d:           ['PENDING','CANCELLED', 'ACCEPTED', 'DISPATCHED', 'DELAYED','DELIVERED','RETURNED']

    },
    computed: {
      ...mapGetters([
        'drivers'
      ]),

      filters() {
        return this.$store.getters.filters;
      },
      pendingEquipmentRequests() {
        return this.equipmentRequests.filter(order => order.status == "PENDING");
      },
      acceptedOrders() {
        return this.equipmentRequests.filter(order => order.status == "ACCEPTED");
      },
      dispatchedEquipmentRequests() {
        return this.equipmentRequests.filter(order => (order.status == "DISPATCHED"))
      },
      deliveredEquipmentRequests() {
        return this.equipmentRequests.filter(order => (order.status == "DELIVERED"))
      },
      returnedEquipmentRequests() {
        return this.equipmentRequests.filter(order => (order.status == "RETURNED"))
      },
    },
    data() {
      return {
        shopProducts: [],
        // equipmentTypes: [],
        activeTab: 0,
        isLoading: false,
        filter: this.filters,
      }
    },
    created() {
      this.getShopProducts(this.filters)
      this.getEquipmentTypes();
      this.getDrivers();
    },
    methods: {
      ...mapActions([
        'getDrivers'
      ]),
      getShopProducts(filters = this.filters) {
        this.shopProducts = [];
        this.isLoading = true;

        this.$store.dispatch('getShopProducts', filters).then(shopProducts => {
          this.isLoading = false;
          this.shopProducts = shopProducts
        }).catch(e => {
          console.log(`Exception when shop products, e:${e}`);
          this.isLoading = false;
        })
      },
      getEquipmentTypes() {
        this.$store.dispatch('getEquipmentTypes').then(({meta, equipmentTypes}) => {
          if (equipmentTypes && equipmentTypes.length > 0) {
            this.equipmentTypes = equipmentTypes
          } else {
            this.$toasted.global.error('Equipment types not found.');
          }
        }).catch(e => {
          console.log('Exception when getting equipment types for Products tabs', e);
          this.$toasted.global.error('Failed to get equipment types.');
        })
      },
      applyFilters({
        start,
        end,
        mobile_number,
        name,
        requestNumber,
        deliveryCities,
        equipmentTypeId
      }) {
        end.setHours(24)
        const fromDate = mdy(start);
        const toDate = mdy(end);
        this.$store.commit('setFilters', {
          fromDate,
          toDate,
          mobile_number,
          name,
          requestNumber,
          deliveryCities,
          equipmentTypeId
        });
        this.getShopProducts();
      },
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Shop/Home.vue